/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceProjectDetailsResource } from './';
import {
    FixedPriceProjectDetailsResourceFromJSON,
    FixedPriceProjectDetailsResourceFromJSONTyped,
    FixedPriceProjectDetailsResourceToJSON,
} from './';
import type { ProjectType } from './';
import {
    ProjectTypeFromJSON,
    ProjectTypeFromJSONTyped,
    ProjectTypeToJSON,
} from './';
import type { TimeAndMaterialsProjectDetailsResource } from './';
import {
    TimeAndMaterialsProjectDetailsResourceFromJSON,
    TimeAndMaterialsProjectDetailsResourceFromJSONTyped,
    TimeAndMaterialsProjectDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDetailsResource
 */
export interface ProjectDetailsResource {
    /**
     * 
     * @type {ProjectType}
     * @memberof ProjectDetailsResource
     */
    type: ProjectType;
}

/**
 * Check if a given object implements the ProjectDetailsResource interface.
 */
export function instanceOfProjectDetailsResource(value: object): value is ProjectDetailsResource {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ProjectDetailsResourceFromJSON(json: any): ProjectDetailsResource {
    return ProjectDetailsResourceFromJSONTyped(json, false);
}

export function ProjectDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDetailsResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return FixedPriceProjectDetailsResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsProjectDetailsResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': ProjectTypeFromJSON(json['type']),
    };
}

export function ProjectDetailsResourceToJSON(value?: ProjectDetailsResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return FixedPriceProjectDetailsResourceToJSON(value as FixedPriceProjectDetailsResource);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsProjectDetailsResourceToJSON(value as TimeAndMaterialsProjectDetailsResource);
        }
    }
    return {
        
        'type': ProjectTypeToJSON(value['type']),
    };
}

